import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { TENANT_MGMT_ROUTES } from '@app/+state/user-data/user.model';
import { UiStateFacade, UserDataFacade } from '@ra-state';
import { Observable, asyncScheduler, iif, mergeMap, of, scheduled, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResourceGuard {
  private readonly userDataFacade = inject(UserDataFacade);
  private readonly router = inject(Router);
  private readonly uiStateFacade = inject(UiStateFacade);


  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const checkManagePermission$ = this.userDataFacade.manageableResources$.pipe(
      switchMap((resources) => {
        if (route.data.canManage(resources)) {
          return scheduled<boolean>([true], asyncScheduler);
        } else {
          const message = 'Insufficient Permissions. Redirecting to dashboard';
          this.uiStateFacade.displayMessage({
            message: message,
            type: 'Error',
          });
          this.router.navigate(['/dashboard']);
          return scheduled<boolean>([false], asyncScheduler);
        }
      }),
    );

    return this.userDataFacade.currentTenantContext$.pipe(
      mergeMap((tenantContext) =>
        iif(
          () => tenantContext === 'NotSelected' || tenantContext === 'Personal',
          of(1).pipe(
            switchMap(() => {
              this.router.navigate([TENANT_MGMT_ROUTES.ORGANIZATIONS]);
              return scheduled<boolean>([false], asyncScheduler);
            }),
          ),
          checkManagePermission$,
        ),
      ),
    );
  }
}
